<p-toast />
<main class="bg-zinc-50 dark:bg-zinc-950">
  <router-outlet />
</main>
